import React, { useState } from 'react';
import { ActionModal } from '../../../../../../ui/components/Modal';
import UnileverImportScanModalFilePane from './panes/UnileverImportScanModalFilePane';
import UnileverImportScanModalUploadPane from './panes/UnileverImportScanModalUploadPane';
import { Order } from '../../../../../order';

interface UnileverImportScanModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;

  order: Order;
}

enum ImportStatus {
  file,
  upload,
}

export default function UnileverImportScanModal({ open, setOpen, order }: UnileverImportScanModalProps) {
  const [status, setStatus] = useState(ImportStatus.file);
  const [file, setFile] = useState<File | null>(null);

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    if (!file) return;

    setStatus(ImportStatus.upload);
  };

  const content = () => {
    switch (status) {
      case ImportStatus.file:
        return (
          <UnileverImportScanModalFilePane
            file={file}
            setFile={setFile}
            handleClose={handleClose}
            handleNext={handleNext}
          />
        );
      case ImportStatus.upload:
        if (!file) return null;
        return <UnileverImportScanModalUploadPane file={file} handleClose={handleClose} order={order} />;
    }
  };

  return (
    <ActionModal open={open} setOpen={setOpen} title={'Import Scan File'}>
      <div className='h-[600px] px-6 py-4'>{content()}</div>
    </ActionModal>
  );
}
